import { Controller } from "@hotwired/stimulus"

// Client-side sorting and per-column filtering for plain HTML tables.
// Replaces the abandoned jquery-datatables + yadcf setup with Hotwire/Stimulus.
//
// Attach to a <table data-controller="table">. Sortable headers carry
// `data-action="click->table#sort"` and `data-column="<index>"`. Filter inputs
// carry `data-action="input->table#filter"` (or `change->table#filter` for
// selects) and `data-column="<index>"`.
export default class extends Controller {
  connect() {
    this.tbody = this.element.tBodies[0]
    this.rows = Array.from(this.tbody.rows)
    this.sortIndex = null
    this.sortDirection = 1
  }

  filter() {
    const filters = Array.from(this.element.querySelectorAll("[data-column]"))
      .filter((input) => (input.tagName === "INPUT" || input.tagName === "SELECT") && input.value !== "")
      .map((input) => ({ index: parseInt(input.dataset.column, 10), value: input.value.toLowerCase() }))

    this.rows.forEach((row) => {
      const visible = filters.every(({ index, value }) => {
        const cell = row.cells[index]
        return cell && cell.textContent.toLowerCase().includes(value)
      })
      row.style.display = visible ? "" : "none"
    })
  }

  sort(event) {
    const header = event.currentTarget
    const index = parseInt(header.dataset.column, 10)

    if (this.sortIndex === index) {
      this.sortDirection *= -1
    } else {
      this.sortIndex = index
      this.sortDirection = 1
    }

    const sorted = [...this.rows].sort((a, b) => {
      const first = this.cellValue(a, index)
      const second = this.cellValue(b, index)

      if (typeof first === "number" && typeof second === "number") {
        return (first - second) * this.sortDirection
      }
      return String(first).localeCompare(String(second), "nl", { numeric: true }) * this.sortDirection
    })

    sorted.forEach((row) => this.tbody.appendChild(row))
    this.updateIndicators(header)
  }

  cellValue(row, index) {
    const cell = row.cells[index]
    if (!cell) return ""
    const text = cell.textContent.trim()
    const number = parseFloat(text.replace(/,/g, "."))
    return text !== "" && !isNaN(number) && /^[\d.,\s]+$/.test(text) ? number : text
  }

  updateIndicators(activeHeader) {
    this.element.querySelectorAll("th[data-column]").forEach((th) => {
      th.classList.remove("sort-asc", "sort-desc")
    })
    activeHeader.classList.add(this.sortDirection === 1 ? "sort-asc" : "sort-desc")
  }
}
